import React from "react";
import { motion } from "framer-motion";
import { Music2, Clapperboard, Footprints, Shirt, Briefcase, Globe2 } from "lucide-react";
import { useI18n } from "../i18n";
import { Section, SectionHeading } from "./Section";
import { PILLARS, IMAGES } from "../data/structure";

const ICONS = {
  music: Music2,
  film: Clapperboard,
  dance: Footprints,
  fashion: Shirt,
  business: Briefcase,
  impact: Globe2,
};

const BG = {
  music: IMAGES.stageLights,
  film: IMAGES.redCarpet,
  dance: IMAGES.lightTrails,
  fashion: IMAGES.redCarpet,
  business: IMAGES.goldStreaks,
  impact: IMAGES.skyline,
};

export default function CareerPillars() {
  const { d } = useI18n();
  return (
    <Section testid="career-pillars">
      <SectionHeading
        kicker={d.pillarsSection.kicker}
        heading={d.pillarsSection.heading}
        subtitle={d.pillarsSection.subtitle}
      />
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {PILLARS.map((key, i) => {
          const Icon = ICONS[key];
          const p = d.pillars[key];
          return (
            <motion.div
              key={key}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              data-testid={`pillar-${key}`}
              className="group relative overflow-hidden rounded-2xl border border-jlo-gold/20 bg-jlo-bg2 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-jlo-gold/60 min-h-[220px] flex flex-col"
            >
              <img
                src={BG[key]}
                alt=""
                aria-hidden="true"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-[0.12] group-hover:opacity-25 transition-opacity duration-500"
              />
              <div className="relative z-10 flex flex-col h-full">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-jlo-gold/30 bg-jlo-bg/60 text-jlo-gold mb-5">
                  <Icon className="h-6 w-6" aria-hidden="true" />
                </span>
                <h3 className="font-display text-2xl font-semibold text-jlo-warm">{p.title}</h3>
                <p className="mt-3 text-sm text-jlo-warm/75 leading-relaxed">{p.body}</p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </Section>
  );
}
